(function () {
  var blogList = document.getElementById('blog-list');
  if (!blogList) return;

  var articlesListing = blogList.querySelector('[data-articles-listing]');
  var filterLinks = document.querySelectorAll('[data-blog-filter]');
  var loader = document.getElementById('blog-loader');
  var activeFilterHandle = normalizeFilter(blogList.getAttribute('data-bloghandle'));
  var first = Math.min(parseInt(blogList.getAttribute('data-page-size'), 10) || 250, 250);
  var nextDelay = parseInt(blogList.getAttribute('data-next-delay'), 10) || 5000;
  var debug = blogList.getAttribute('data-debug') === 'true';
  var endpoint = blogList.getAttribute('data-endpoint');
  var storefrontToken = blogList.getAttribute('data-storefront-token');
  var placeholderImage = blogList.getAttribute('data-placeholder-image') || '';
  var isLoading = false;
  var totalFetched = 0;
  var totalRendered = 0;
  var requestCount = 0;
  var paginationTimer = null;

  var articleFields = `
    nodes {
      content
      contentHtml
      excerpt
      excerptHtml
      handle
      id
      image {
        previewUrl: url(transform: { maxWidth: 40 })
        url(transform: { maxWidth: 1000 })
        altText
        width
        height
      }
      onlineStoreUrl
      publishedAt
      tags
      title
      trackingParameters
      blog {
        handle
        id
        onlineStoreUrl
        title
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  `;

  var allArticlesQuery = `
    query ArticlesPage($first: Int!, $after: String) {
      articles(first: $first, after: $after, sortKey: UPDATED_AT, reverse: true) {
        ${articleFields}
      }
    }
  `;

  function normalizeFilter(value) {
    value = (value || '').trim();
    return value === 'all' ? '' : value;
  }

  function setLoader(visible, text) {
    if (!loader) return;
    loader.hidden = !visible;
    if (text) loader.textContent = text;
  }

  function logBlogFetch(message, data) {
    if (!debug) return;
    console.info('[blog graphql] ' + message, data || '');
  }

  function logRequestStatus(requestNumber, status, data) {
    logBlogFetch('request #' + requestNumber + ' - ' + status, data);
  }

  function setActiveFilter(filterHandle) {
    filterLinks.forEach(function (link) {
      var linkHandle = normalizeFilter(link.getAttribute('data-blog-filter'));
      link.classList.toggle('active', linkHandle === filterHandle);
    });
  }

  function showShimmer(count) {
    var fragment = document.createDocumentFragment();
    var shimmerCount = Math.min(Math.max(count || 6, 3), 12);

    for (var index = 0; index < shimmerCount; index += 1) {
      var item = document.createElement('div');
      item.className = 'blog-articles blog-article-shimmer';
      item.setAttribute('data-blog-shimmer', '');
      item.setAttribute('aria-hidden', 'true');
      item.style.transitionDelay = Math.min(index, 12) * 35 + 'ms';
      item.innerHTML = `
        <div class="article-image">
          <span class="blog-article-shimmer__block blog-article-shimmer__image"></span>
        </div>

        <h6>
          <span class="blog-article-shimmer__block blog-article-shimmer__title"></span>
        </h6>

        <div class="excerpt">
          <span class="blog-article-shimmer__block blog-article-shimmer__line"></span>
          <span class="blog-article-shimmer__block blog-article-shimmer__line blog-article-shimmer__line--short"></span>
        </div>
      `;
      fragment.appendChild(item);
    }

    articlesListing.appendChild(fragment);

    window.requestAnimationFrame(function () {
      articlesListing.querySelectorAll('[data-blog-shimmer]').forEach(function (item) {
        item.classList.add('is-visible');
      });
    });
  }

  function getPendingShimmerCards() {
    return Array.prototype.slice.call(articlesListing.querySelectorAll('[data-blog-shimmer]'));
  }

  function removeUnusedShimmer(count) {
    getPendingShimmerCards().slice(count || 0).forEach(function (node) {
      node.remove();
    });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function stripHtml(html) {
    var div = document.createElement('div');
    div.innerHTML = html || '';
    return div.textContent || div.innerText || '';
  }

  function truncateWords(text, limit) {
    var words = String(text || '').trim().split(/\s+/).filter(Boolean);
    return words.length > limit ? words.slice(0, limit).join(' ') + '...' : words.join(' ');
  }

  function storefrontPath(url) {
    if (!url) return '#';

    try {
      var parsed = new URL(url);
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (error) {
      return url;
    }
  }

  function getExcerpt(article) {
    if (article.excerptHtml) return article.excerptHtml;
    if (article.excerpt) return escapeHtml(article.excerpt);

    return escapeHtml(truncateWords(stripHtml(article.contentHtml || article.content), 40));
  }

  function articleMatchesFilter(articleNode, filterHandle) {
    return !filterHandle || articleNode.getAttribute('data-article-bloghandle') === filterHandle;
  }

  function upgradeProgressiveImage(image) {
    var fullSrc = image.getAttribute('data-full-src');
    if (!fullSrc || image.src === fullSrc) return;

    var fullImage = new Image();
    fullImage.onload = function () {
      image.src = fullSrc;
      image.classList.add('is-loaded');
    };
    fullImage.src = fullSrc;
  }

  function handlePreviewImageLoad(image) {
    var imageWrap = image.closest('.article-image');

    function markPreviewLoaded() {
      if (imageWrap) imageWrap.classList.remove('is-preview-loading');
      image.classList.add('is-preview-loaded');
      upgradeProgressiveImage(image);
    }

    image.addEventListener('load', markPreviewLoaded, { once: true });
    image.addEventListener('error', markPreviewLoaded, { once: true });

    if (image.complete) {
      markPreviewLoaded();
    }
  }

  function backgroundImageStyle(url) {
    if (!url) return '';
    return ' style="background-image: url(&quot;' + escapeHtml(url) + '&quot;);"';
  }

  function renderArticle(article, articleNode) {
    var articleUrl = storefrontPath(article.onlineStoreUrl);
    var articleBlogHandle = article.blog && article.blog.handle ? article.blog.handle : '';
    var imageUrl = article.image && article.image.url ? article.image.url : placeholderImage;
    var previewImageUrl = article.image && article.image.previewUrl ? article.image.previewUrl : imageUrl;
    var imageAlt = article.image && article.image.altText ? article.image.altText : article.title;

    articleNode.className = 'blog-articles';
    articleNode.removeAttribute('data-blog-shimmer');
    articleNode.removeAttribute('aria-hidden');
    articleNode.setAttribute('data-article-bloghandle', articleBlogHandle);
    articleNode.hidden = activeFilterHandle !== '' && activeFilterHandle !== articleBlogHandle;
    articleNode.innerHTML = `
      <div class="article-image has-progressive-preview is-preview-loading"${backgroundImageStyle(previewImageUrl)}>
        <a href="${escapeHtml(articleUrl)}">
          <img
            src="${escapeHtml(previewImageUrl)}"
            data-full-src="${escapeHtml(imageUrl)}"
            alt="${escapeHtml(imageAlt)}"
            height="200"
            width="200"
            loading="lazy"
            class="progressive-article-image"
          >
        </a>
      </div>

      <h6>
        <a href="${escapeHtml(articleUrl)}">
          ${escapeHtml(article.title)}
        </a>
      </h6>

      <div class="excerpt">
        ${getExcerpt(article)}
      </div>
    `;

    totalRendered += 1;

    var image = articleNode.querySelector('.progressive-article-image');
    if (image) handlePreviewImageLoad(image);
  }

  function renderArticlesFromResponse(articles) {
    var shimmerCards = getPendingShimmerCards();

    articles.forEach(function (article, index) {
      var articleNode = shimmerCards[index] || document.createElement('div');

      if (!shimmerCards[index]) {
        articlesListing.appendChild(articleNode);
      }

      renderArticle(article, articleNode);
    });

    removeUnusedShimmer(articles.length);
  }

  function getRenderedArticles() {
    return Array.prototype.slice.call(articlesListing.querySelectorAll('[data-article-bloghandle]'));
  }

  function applyMasonryFilter(filterHandle) {
    var articles = getRenderedArticles();
    var visibleCount = 0;

    articles.forEach(function (articleNode) {
      var shouldShow = articleMatchesFilter(articleNode, filterHandle);
      articleNode.hidden = !shouldShow;
      if (shouldShow) visibleCount += 1;
    });

    articlesListing.offsetHeight;

    logBlogFetch('filter applied without new request', {
      handle: filterHandle || null,
      visibleArticles: visibleCount,
      totalFetched: totalFetched,
      totalRendered: totalRendered,
      totalRequests: requestCount
    });
  }

  function scrollToPageTop() {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    } catch (error) {
      window.scrollTo(0, 0);
    }
  }

  async function fetchArticles(cursor) {
    if (isLoading) return;

    if (!endpoint || !storefrontToken) {
      setLoader(true, 'Storefront API settings are missing.');
      return;
    }

    isLoading = true;
    requestCount += 1;

    var requestNumber = requestCount;

    setLoader(false);
    showShimmer(cursor ? Math.min(first, 6) : Math.min(first, 9));
    logRequestStatus(requestNumber, 'Progress', {
      mode: 'all_articles',
      activeFilter: activeFilterHandle || null,
      first: first,
      after: cursor || null,
      totalFetched: totalFetched,
      totalRendered: totalRendered
    });

    try {
      var response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontToken
        },
        body: JSON.stringify({
          query: allArticlesQuery,
          variables: {
            first: first,
            after: cursor || null
          }
        })
      });

      var payload = await response.json();

      if (!response.ok || payload.errors) {
        throw new Error(payload.errors ? payload.errors[0].message : 'Unable to load blog articles.');
      }

      var connection = payload.data.articles;
      var articles = connection.nodes;
      var pageInfo = connection.pageInfo;

      totalFetched += articles.length;
      renderArticlesFromResponse(articles);

      logRequestStatus(requestNumber, 'Done', {
        mode: 'all_articles',
        activeFilter: activeFilterHandle || null,
        returned: articles.length,
        totalFetched: totalFetched,
        totalRendered: totalRendered,
        hasNextPage: pageInfo.hasNextPage,
        endCursor: pageInfo.endCursor
      });

      if (pageInfo.hasNextPage) {
        paginationTimer = window.setTimeout(function () {
          fetchArticles(pageInfo.endCursor);
        }, nextDelay);
      } else {
        logBlogFetch('all articles loaded', {
          totalRequests: requestCount,
          totalFetched: totalFetched,
          totalRendered: totalRendered
        });
      }
    } catch (error) {
      removeUnusedShimmer(0);
      setLoader(true, error.message || 'Unable to load blog articles.');
      logRequestStatus(requestNumber, 'Failed', {
        message: error.message || 'Unable to load blog articles.',
        totalFetched: totalFetched,
        totalRendered: totalRendered
      });
    } finally {
      isLoading = false;
    }
  }

  function applyFilter(filterHandle) {
    activeFilterHandle = filterHandle;
    blogList.setAttribute('data-bloghandle', activeFilterHandle);
    setActiveFilter(activeFilterHandle);

    logBlogFetch('filter changed', {
      mode: 'client_filter',
      handle: activeFilterHandle || null
    });

    applyMasonryFilter(activeFilterHandle);
    scrollToPageTop();
  }

  filterLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
      var filterHandle = normalizeFilter(link.getAttribute('data-blog-filter'));

      event.preventDefault();
      if (filterHandle === activeFilterHandle) return;

      applyFilter(filterHandle);
    });
  });

  setActiveFilter(activeFilterHandle);
  fetchArticles(null);
})();
